/* tslint:disable */
/* eslint-disable */
export enum CustomerPersonTypeEnum {
  NotSet = 0,
  ContactPerson = 1,
  PersonOfInterestNotification = 2
}
